import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Flex } from '@televet/kibble-ui/chakra';

export const Route = createFileRoute('/dev/OttoPilot')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Flex h="100vh" w="100%">
      <Outlet />
    </Flex>
  );
}
